module.exports = __webpack_public_path__ + "static/media/gif2.7eeda185.gif";